import React from 'react';
import Manage from './Manage';
import { DataCategoriesProvider } from '../../../contexts/DataCategoryContext';

const Page = () => {
    return (
        <>
            <DataCategoriesProvider>
                <Manage />
            </DataCategoriesProvider>
        </>
    );
};

export default Page;
